import { render, staticRenderFns } from "./Statements-pagination.vue?vue&type=template&id=45465c76"
import script from "./Statements-pagination.vue?vue&type=script&lang=js"
export * from "./Statements-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports